    import React, { useEffect, useState } from 'react';

    const ProductPriceChange = (props) => {

  
  return (
    <div>
      <div className="container mb-4">
        <form>
          <>
            <div className="row mt-2">
              <div className="col-md-4 ">
                <label className="form-label label-txt col-md-7">
                  Product MRP
                </label>
                <input type="text" className="form-control"
                  defaultValue={props.changePrice && props.changePrice.mrp}
                onChange={(e) => props.setChangePrice({...props.changePrice,mrp:e.target.value})} />
                {props.updatePriceError && props.updatePriceError ? <p style={{color : 'red' , fontSize : 12}}>{props.updatePriceError.mrp}</p> : ''}
              </div>
              <div className="col-md-4 ">
                <label className="form-label label-txt col-md-7">
                  Product Price
                </label>
                <input type="text"  className="form-control" 
                  defaultValue={props.changePrice && props.changePrice.price}
                onChange={(e) => props.setChangePrice({...props.changePrice, price:e.target.value})} />
                {props.updatePriceError && props.updatePriceError ? <p style={{color : 'red' , fontSize : 12}}>{props.updatePriceError.price}</p> : ''}
              </div>
             <div className="col-md-4 ">
                <label className="form-label label-txt col-md-7">Stock</label>
                <input type="text" className="form-control" defaultValue={props.changePrice && props.changePrice.stock} 
                   onChange={(e) => props.setChangePrice({...props.changePrice, stock:e.target.value})}
                />
                {props.updatePriceError && props.updatePriceError ? <p style={{color : 'red' , fontSize : 12}}>{props.updatePriceError.stock}</p> : ''}
              </div>
              </div>
          </>
        </form>
      </div>
    </div>
  );
};

export default ProductPriceChange;